import { trace } from 'rytm-helpers'
import Controller from './Controller'
import { 
  initPlayground, 
  nextPlayground, 
  destroyPlayground, 
  stopPlayground 
} from '../playground'


let anyInteractionOccured = false

class HomePlayController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    if (anyInteractionOccured) {
      this.startPlayground();
    }
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e);
    // ### Playground ###
    destroyPlayground();
    document.documentElement.classList.remove('playground-menu-open');
    document.body.classList.remove('user-interaction');
  }
  addEventListeners() {
    super.addEventListeners();
    $("body").on("touchstart click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this));
    $("body").on("keydown", $.proxy(this.onUserInteraction, this));
    // controls
    $("body").on("click", ".playground-menu-expand", $.proxy(this.onMenuExpand, this));
    $("body").on("click", ".playground-menu-close", $.proxy(this.onMenuClose, this));
    $("body").on("click", ".playground-func", $.proxy(this.onFuncClick, this));
  }
  removeEventListeners() {
    super.removeEventListeners();
    $("body").off("touchstart click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this));
    $("body").off("keydown", $.proxy(this.onUserInteraction, this));
    // controls
    $("body").off("click", ".playground-menu-expand", $.proxy(this.onMenuExpand, this));
    $("body").off("click", ".playground-menu-close", $.proxy(this.onMenuClose, this));
    $("body").on("click", ".playground-func", $.proxy(this.onFuncClick, this));
    // ### Playground ###
    stopPlayground();
  }
  /**
   * ###########
   * ### OWN ###
   */
   onUserInteraction(e) {
    $("body").off("click", ".editionhome-playground-intro", $.proxy(this.onUserInteraction, this));
    $("body").off("keydown", $.proxy(this.onUserInteraction, this));
    if (!anyInteractionOccured) {
      this.startPlayground();
    }
  }
  onFuncClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.disableFuncClick) return;
    // ### Playground ###
    if (anyInteractionOccured) {
      this.disableFuncClick = true;
      document.documentElement.classList.add('playground-transformation');
      stopPlayground(() => {
        this.disableFuncClick = false;
        document.documentElement.classList.remove('playground-transformation');
        nextPlayground();
      });
    } else {
      this.startPlayground();
    }
  }
  startPlayground() {
    anyInteractionOccured = true;
    document.body.classList.add('user-interaction');
    document.documentElement.classList.add('playground-transformation');
    // ### Playground ###
    initPlayground(() => {
      document.documentElement.classList.remove('playground-transformation');
      nextPlayground();
    });
  }
  onMenuExpand(e) {
    e.preventDefault();
    e.stopPropagation();
    document.documentElement.classList.add('playground-menu-open');
  }
  onMenuClose(e) {
    e.preventDefault();
    e.stopPropagation();
    document.documentElement.classList.remove('playground-menu-open');
  }
  
   
}

export default HomePlayController;